import { View, Text, StyleSheet } from "react-native";
import React from "react";

import { colors } from "@constants/theme";
import CMLogo from "@assets/svg/CMLogo";

const ConnectedByCM = ({ show }) => {
  if (show) {
    return (
      <View
        style={[
          styles.container,
          {
            borderWidth: 1,
            borderColor: colors.lighterBlack,
          },
        ]}
      >
        <CMLogo />
        <Text style={styles.text}>सिटीमॉल ने जोड़ा</Text>
      </View>
    );
  }
  return <View style={styles.container} />;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 10,
    width: 105,
    height: 20,
    padding: 2,
    justifyContent: "center",
    alignSelf: "flex-start",
  },
  text: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 11,
    fontWeight: "700",
    textAlign: "left",
    color: colors.lightBlack,
    marginHorizontal: 2,
  },
});

export default ConnectedByCM;
